import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../../environments/environment';
// ngrx store
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { map, take } from 'rxjs/operators';
// services
import { EventsService } from '../../services/events.service';
import { BookingService } from '../../services/booking.service';
import { FlightDetailsService } from '../../../shared/services/flight-details.service';
import { DataStorageService } from '../../../shared/services/data-storage.service';
import { AppLoaderService } from '../../../shared/services/app-loader.service';
import { ExponeaBannerService } from '../../../shared/services/exponea-banner.service';
// models
import { AppState } from '../../models/app-state.interface';
import { FlightAPIRequest } from '../../models/flight-request.interface';
import { LoadingStatusInitState } from '../../../shared/models/loading-status.interface';
// globals
import { EMAIL_PATTERN } from '../../../shared/globals';

declare var exponea: any;
@Component({
  selector: 'app-upsell-booking',
  templateUrl: './upsell-booking.component.html',
  styleUrls: ['./upsell-booking.component.scss']
})
export class UpsellBookingComponent implements OnInit, OnDestroy {


  @Input()
  styledClass;

  @Input()
  appCopy

  @Input()
  selectedLanguage

  private _upsellBookingSubscription: Subscription;
  private _bookingInitSubscription: Subscription;

  public bookingInit: Boolean = false;
  private _firstLoad = true;
  private _subscriptionsSet = false;
  public upsellbookingStatus: any = {};
  public canPay = false;
  public isEmailScreen = false;
  public airlineCode;
  public operatedAirlineNumber;
  public departureAirportCode;
  public arrivalAirportCode;
  public departureAirportCityName;
  public departureDate;
  public arrivalAirportCityName;
  public flightData;
  public flightDirection;
  public startPrice = '';
  public userData = {
    bookerEmail: ''
  }
  public emailPattern = EMAIL_PATTERN;

  constructor(
    private _appStore: Store<AppState>,
    private _flightDetailsService: FlightDetailsService,
    private _dataStorageService: DataStorageService,
    private _eventsService: EventsService,
    private _appLoaderService: AppLoaderService,
    private _bookingService: BookingService,
    private _exponeaBanner: ExponeaBannerService,
  ) { }

  ngOnInit(): void {
    this._bookingInitSubscription = this._appStore.select('loadedStatusReducer')
      .subscribe((res: LoadingStatusInitState) => {
        // if booking data has bookingLoaded
        // show template and subscribe to data
        if (res.currentBookingLoaded && res.userLoaded && res.airportLocationsLoaded && this._firstLoad && !this._subscriptionsSet) {
          this.bookingInit = res.currentBookingLoaded;
          this._firstLoad = false;
          this.setDataSubscriptions();

          // if (res.copyLoaded) {
          //   if (isPlatformBrowser(this.platformId)) {
          //     this.getCopy();
          //   }
          // }

        } else {
          return;
        }
      });
  }

  setDataSubscriptions() {
    const state = this.getState(this._appStore);
    this.flightData = state.flightReducer.flightDetails;
    this.flightDirection = state.bookingReducer.bookingDetails.journeyLegDetails[0].journeyDirection;

    const flight = this.flightData.flightResponse;
    this.airlineCode = flight.flightStatusDetails[flight.flightStatusDetails.length - 1].airlineCode + flight.flightStatusDetails[flight.flightStatusDetails.length - 1].flightNumber;
    this.operatedAirlineNumber = flight.flightStatusDetails[flight.flightStatusDetails.length - 1].operatingFlightNumber;
    this.departureAirportCode = flight.flightStatusDetails[0].departureAirport.airportCode;
    this.departureAirportCityName = flight.flightStatusDetails[0].departureAirport.airportCityName;
    this.departureDate = flight.flightStatusDetails[0].departureDateTimeDetails.scheduledDate;
    this.arrivalAirportCode = flight.flightStatusDetails[flight.flightStatusDetails.length - 1].arrivalAirport.airportCode;
    this.arrivalAirportCityName = flight.flightStatusDetails[flight.flightStatusDetails.length - 1].arrivalAirport.airportCityName;

    this.startPrice = this.flightDirection === 1 ? state.d2dReducer.inboundPrice : state.d2dReducer.outboundPrice;

    const currentBooking = state.upsellBookingReducer.currentBooking;
    if (currentBooking === 'abc') {
      this.canPay = !!state.d2dReducer.inboundBooking.isCompleted;
    } else {
      this.canPay = !!state.d2dReducer.outboundBooking.isCompleted;
    }

    this._upsellBookingSubscription = this._appStore.select('upsellBookingReducer')
      .subscribe(res => {
        this.upsellbookingStatus = res;
        this.isEmailScreen = (!res.abcTimeslotsAvailable && !res.ccdTimeslotsAvailable) || this.canPay;
        if(this.isEmailScreen) {
          exponea.track('no_collection_slot_available', {entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',});
        }
      });


    this._dataStorageService.saveData();
    this._subscriptionsSet = true;
  }

  makeUpsellBooking() {
    this._appLoaderService.showLoader('', true);
    const bookingState = this.getState(this._appStore);
    const d2dBookingReducer = bookingState.d2dReducer;
    const flightReducer = bookingState.flightReducer;

    // get flight products from d2d and update in flight reducer
    const productAvailability = flightReducer.flightDetails.flightResponse.productAvailability;
    const flightProductsAvailable = d2dBookingReducer.flightDetails.flightProducts;
    const flightResponse = JSON.parse(JSON.stringify(flightReducer.flightDetails.flightResponse));

    let flightAvailability = {
      abcAvailable: !productAvailability.abcAvailable,
      ccdAvailable: !productAvailability.ccdAvailable,
      sdsAvailable: flightProductsAvailable.sds,
      isDomesticABC: flightProductsAvailable.isDomesticABC,
      journeyDirection: 2
    };

    if (productAvailability.ccdAvailable) {
      flightAvailability = {
        abcAvailable: !productAvailability.abcAvailable,
        ccdAvailable: !productAvailability.ccdAvailable,
        sdsAvailable: flightProductsAvailable.sds,
        isDomesticABC: flightProductsAvailable.isDomesticABC,
        journeyDirection: 1
      }
    }

    // call getFlightStatus api for 2nd booking type
    const nextFlightDirection = productAvailability.abcAvailable ? 2 : 1;
    flightResponse.productAvailability = flightAvailability;

    // call getFlightStatsData()
    const flight = flightResponse;
    const isMultiLegFlight = flightResponse.totalNumberOfLegs > 1;
    flight.flightDirection = nextFlightDirection;
    let request: FlightAPIRequest = {
      firstLeg: {
        flightNumber: flight.flightStatusDetails[0].airlineCode + flight.flightStatusDetails[0].flightNumber,
        flightDirection: nextFlightDirection,
        departureDate: nextFlightDirection == 1
          ? flight.flightStatusDetails[0].departureDateTimeDetails.scheduledDateTimeLocal
          : flight.flightStatusDetails[0].arrivalDateTimeDetails.scheduledDateTimeLocal,
        isPrimary: true
      }
    };

    if (isMultiLegFlight || flight.productAvailability === null) {
      request.firstLeg.isPrimary = flight.flightStatusDetails[0].isPrimaryLeg;

      request.lastLeg = {
        flightNumber: flight.flightStatusDetails[flight.flightStatusDetails.length - 1].airlineCode + flight.flightStatusDetails[flight.flightStatusDetails.length - 1].flightNumber,
        flightDirection: nextFlightDirection,
        departureDate: nextFlightDirection == 1
          ? flight.flightStatusDetails[flight.flightStatusDetails.length - 1].departureDateTimeDetails.scheduledDateTimeLocal
          : flight.flightStatusDetails[flight.flightStatusDetails.length - 1].arrivalDateTimeDetails.scheduledDateTimeLocal,
        isPrimary: flight.flightStatusDetails[flight.flightStatusDetails.length - 1].isPrimaryLeg
      };
    }

    if (isMultiLegFlight && flightAvailability.ccdAvailable && !flightAvailability.abcAvailable) {
      request.firstLeg.isPrimary = false;
      request.lastLeg.isPrimary = true;
      request.lastLeg.flightDirection = 2;
    }

    const availableProductTypes = JSON.parse(JSON.stringify(d2dBookingReducer.flightDetails.flightProducts));
    const _productAvailability = {
      abcAvailable: availableProductTypes.abc,
      ccdAvailable: availableProductTypes.ccd,
      sdsAvailable: availableProductTypes.sds,
      isDomesticABC: availableProductTypes.isDomesticABC
    }

    const currentBooking = availableProductTypes.abc ? 'abc' : 'ccd';
    const upsellBooking = availableProductTypes.abc ? 'ccd' : 'abc';
    // exponea event
    this.triggerEvent();
    // reset reducers
    this._bookingService.updateD2dstate();
    this._appStore.dispatch({ type: 'UPSELL_BOOKING_STATUS', payload: {showUpsellScreen: false, currentBooking: currentBooking, upsellBooking: upsellBooking, upsellConverted: true} });
    this._appStore.dispatch({ type: 'RESET_PRICE' });
    this._appStore.dispatch({ type: 'RESET_TIMESLOT_STATE' });
    this._appStore.dispatch({ type: 'RESET_BOOKING_OBJECT' });
    this._appStore.dispatch({ type: "RESET_HUBDROP_REDUCER" });
    // this._appStore.dispatch({ type: 'RESET_BOOKING_STATE' });
    this._appStore.dispatch({ type: 'SELECTED_SERVICE_TYPE', payload: 'd2d' });
    this._flightDetailsService.getFlightStatsData(flight, request, false, false, false, true, _productAvailability);
  }

  gotoHome(email?) {
    this.consentEvent(email);
    this.triggerEvent()
    window.location.replace(environment.homeURL);
    exponea.track('no_collection_website_click', {
      'email': email,
      entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
    });
  }

  goForPayment(email) {
    const state = this.getState(this._appStore);
    this.consentEvent(email);
    this.triggerEvent();
    const payFor = state.bookingReducer.bookingDetails.bookingProduct === 'abc' ? 'ccd' : 'abc';
    this._appStore.dispatch({ type: 'UPDATE_D2D_SERVICE', payload: false });
    this._eventsService.goToBookingSwitcher(payFor, 'payment');
    return
  }

  consentEvent(email) {
    if (email) {
      const touchpoint = 'noslot_availability_' + this.getState(this._appStore).d2dReducer.userSelectedServicetype as any;
      this._exponeaBanner.trackOptIn({
        category: 'email', email,
        touchpoint: 'oldfunnel_'+touchpoint as any,
      });
      // exponea.track('consent', {
      //   'email_id': email,
      //   action: 'accept',
      //   touchpoint: touchpoint,
      //   category: 'email',
      //   valid_until: 'unlimited',
      //   entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
      // });
    }
  }

  triggerEvent() {
    const state = this.getState(this._appStore);
    const touchpoint = 'noslot_availability_' + state.d2dReducer.userSelectedServicetype;
    const zoneInfo = state.bookingReducer.bookingDetails.zoneInfo;

    exponea.track(touchpoint, {
      operated_flightnumber: this.operatedAirlineNumber,
      flight_departure_date: this.departureDate,
      zone_name: zoneInfo.zoneId,
      zone_description: zoneInfo.zoneDescription,
      entry_source: this.getState(this._appStore).d2dReducer.entrySource || 'direct',
    });
  }

  // get store state
  getState(store: Store<AppState>) {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

  ngOnDestroy() {
    this._bookingInitSubscription.unsubscribe();
    if (this._upsellBookingSubscription) { this._upsellBookingSubscription.unsubscribe() }
  }
}
